import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

const Summary = ({ summary }) => <div dangerouslySetInnerHTML={{ __html: summary }} />;

Summary.propTypes = {
  summary: PropTypes.string.isRequired,
};

const mapStateToProps = ({ detailsPage }) => ({
  summary: detailsPage.loadedProduct.summary,
});

export default connect(mapStateToProps)(Summary);
